export const categories = [
  { id: "dianying", name: "电影", slug: "dianying", icon: "ri-movie-2-line", count: 1280 },
  { id: "dianshiju", name: "电视剧", slug: "dianshiju", icon: "ri-tv-2-line", count: 960 },
  { id: "zongyi", name: "综艺", slug: "zongyi", icon: "ri-emotion-laugh-line", count: 720 },
  { id: "dongman", name: "动漫", slug: "dongman", icon: "ri-rocket-2-line", count: 850 },
  { id: "jiaoyu", name: "教育", slug: "jiaoyu", icon: "ri-book-open-line", count: 640 },
  { id: "tiyu", name: "体育", slug: "tiyu", icon: "ri-basketball-line", count: 430 },
  { id: "yinyue", name: "音乐", slug: "yinyue", icon: "ri-music-2-line", count: 560 },
  { id: "keji", name: "科技", slug: "keji", icon: "ri-cpu-line", count: 380 },
];

export const videos = [
  {
    id: 1,
    title: "星际穿越 - 穿越时空的壮丽旅程",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20astronaut%20floating%20near%20a%20wormhole%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20vast%20cosmic%20landscape%2C%20deep%20space%20background%2C%20film%20poster%20aesthetic%20with%20warm%20golden%20tones%2C%20professional%20movie%20photography&width=800&height=450&seq=video-thumb-01&orientation=landscape",
    duration: "2:49:15",
    views: 1280000,
    rating: 9.4,
    description: "一部震撼人心的科幻巨制，讲述人类穿越虫洞寻找新家园的伟大冒险。",
    tags: ["科幻", "冒险", "经典"],
  },
  {
    id: 2,
    title: "地球脉动第三季 - 自然奇观纪录片",
    category: "jiaoyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20diverse%20wildlife%20animals%20in%20their%20natural%20habitat%2C%20lush%20green%20forest%20and%20ocean%20views%2C%20warm%20natural%20lighting%2C%20BBC%20documentary%20style%2C%20professional%20wildlife%20photography%2C%20rich%20earthy%20tones&width=800&height=450&seq=video-thumb-02&orientation=landscape",
    duration: "58:30",
    views: 896000,
    rating: 9.7,
    description: "BBC倾力打造的自然纪录片巅峰之作，展现地球上最壮美的自然景观。",
    tags: ["自然", "纪录片", "BBC"],
  },
  {
    id: 3,
    title: "甄嬛传 - 经典宫斗剧完整版",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20palace%20drama%20scene%20with%20traditional%20hanfu%20costumes%2C%20imperial%20palace%20interior%2C%20warm%20candlelight%20ambiance%2C%20classical%20Chinese%20aesthetic%2C%20soft%20golden%20and%20red%20tones%2C%20cinematic%20television%20drama%20photography&width=800&height=450&seq=video-thumb-03&orientation=landscape",
    duration: "76集全",
    views: 2560000,
    rating: 9.3,
    description: "清宫大戏，演绎后宫争斗与人性的复杂，华语电视剧的里程碑之作。",
    tags: ["古装", "宫斗", "经典"],
  },
  {
    id: 4,
    title: "海贼王 - 热血冒险动漫连载",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20anime%20adventure%20scene%20with%20pirate%20ship%20sailing%20on%20vast%20ocean%2C%20colorful%20sunset%20sky%2C%20dynamic%20action%20composition%2C%20warm%20golden%20and%20orange%20tones%2C%20anime%20art%20style%2C%20thrilling%20atmosphere&width=800&height=450&seq=video-thumb-04&orientation=landscape",
    duration: "1088集更新中",
    views: 3980000,
    rating: 9.5,
    description: "路飞与伙伴们的伟大航路冒险，热血与友情交织的传奇故事。",
    tags: ["热血", "冒险", "日漫"],
  },
  {
    id: 5,
    title: "NBA总决赛2024 - 巅峰对决全记录",
    category: "tiyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Intense%20NBA%20basketball%20finals%20game%20moment%20with%20players%20dunking%2C%20packed%20arena%20stadium%20atmosphere%2C%20dramatic%20court%20lighting%2C%20sports%20photography%20style%2C%20dynamic%20action%20shot%2C%20warm%20arena%20lights%20and%20dark%20background&width=800&height=450&seq=video-thumb-05&orientation=landscape",
    duration: "2:15:40",
    views: 1850000,
    rating: 9.1,
    description: "年度最令人期待的篮球盛宴，见证冠军诞生的每一个精彩瞬间。",
    tags: ["篮球", "NBA", "总决赛"],
  },
  {
    id: 6,
    title: "周杰伦2024世界巡回演唱会",
    category: "yinyue",
    thumbnail: "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dazzling%20lighting%20effects%2C%20massive%20crowd%20atmosphere%2C%20spectacular%20stage%20design%2C%20colorful%20laser%20lights%2C%20music%20performance%20photography%2C%20warm%20spotlight%20and%20dark%20audience%20contrast&width=800&height=450&seq=video-thumb-06&orientation=landscape",
    duration: "3:12:00",
    views: 920000,
    rating: 9.6,
    description: "华语乐坛天王的震撼现场，经典歌曲与新作的完美演绎。",
    tags: ["演唱会", "周杰伦", "音乐"],
  },
  {
    id: 7,
    title: "人工智能革命 - 深度学习揭秘",
    category: "keji",
    thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20visualization%20with%20neural%20network%20connections%2C%20digital%20brain%20patterns%2C%20clean%20modern%20tech%20aesthetic%2C%20warm%20golden%20circuit%20lines%20on%20dark%20background%2C%20scientific%20visualization%20style&width=800&height=450&seq=video-thumb-07&orientation=landscape",
    duration: "45:20",
    views: 670000,
    rating: 9.2,
    description: "深入浅出讲解人工智能核心原理，带你走进深度学习的奇妙世界。",
    tags: ["AI", "科技", "深度学习"],
  },
  {
    id: 8,
    title: "奔跑吧兄弟第十季 - 爆笑综艺",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Fun%20outdoor%20variety%20show%20scene%20with%20group%20of%20celebrities%20playing%20games%2C%20bright%20sunny%20day%2C%20colorful%20set%20design%2C%20laughing%20expressions%2C%20entertainment%20show%20photography%2C%20warm%20natural%20lighting%20with%20vibrant%20colors&width=800&height=450&seq=video-thumb-08&orientation=landscape",
    duration: "1:35:00",
    views: 1560000,
    rating: 8.9,
    description: "跑男团全新一季爆笑来袭，更有趣的游戏，更精彩的挑战！",
    tags: ["综艺", "真人秀", "搞笑"],
  },
  {
    id: 9,
    title: "肖申克的救赎 - 永恒经典电影",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Cinematic%20prison%20drama%20scene%20with%20hope%20and%20redemption%20theme%2C%20rainy%20atmosphere%2C%20dramatic%20lighting%20through%20prison%20bars%2C%20classic%20film%20aesthetic%2C%20warm%20sepia%20tones%2C%20emotional%20movie%20photography%20with%20strong%20contrast&width=800&height=450&seq=video-thumb-09&orientation=landscape",
    duration: "2:22:33",
    views: 1890000,
    rating: 9.7,
    description: "希望是美好的，也许是世间最美好的东西，而美好的事物永不消逝。",
    tags: ["剧情", "经典", "励志"],
  },
  {
    id: 10,
    title: "Python编程从入门到精通",
    category: "jiaoyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20coding%20workspace%20with%20laptop%20showing%20Python%20code%2C%20clean%20minimalist%20desk%20setup%2C%20warm%20desk%20lamp%20lighting%2C%20educational%20technology%20photography%2C%20soft%20neutral%20background%2C%20professional%20programming%20aesthetic&width=800&height=450&seq=video-thumb-10&orientation=landscape",
    duration: "12:30:00",
    views: 450000,
    rating: 9.0,
    description: "零基础系统学习Python编程，涵盖基础语法到项目实战全流程。",
    tags: ["编程", "Python", "入门"],
  },
  {
    id: 11,
    title: "鬼灭之刃 - 锻刀村篇全集",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20action%20scene%20with%20swordsman%20in%20epic%20battle%2C%20flame%20effects%2C%20traditional%20Japanese%20aesthetic%2C%20dramatic%20color%20contrast%2C%20warm%20fire%20and%20dark%20shadow%20composition%2C%20animation%20art%20style&width=800&height=450&seq=video-thumb-11&orientation=landscape",
    duration: "25:00x11",
    views: 2100000,
    rating: 9.4,
    description: "炭治郎与伙伴们的新冒险，惊心动魄的战斗与感人至深的故事。",
    tags: ["热血", "战斗", "日漫"],
  },
  {
    id: 12,
    title: "舌尖上的中国第四季",
    category: "jiaoyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20traditional%20dishes%2C%20rustic%20kitchen%20setting%2C%20warm%20natural%20light%2C%20authentic%20Chinese%20culinary%20photography%2C%20rich%20warm%20tones%2C%20appetizing%20food%20aesthetic%20with%20cultural%20elements&width=800&height=450&seq=video-thumb-12&orientation=landscape",
    duration: "50:00x8",
    views: 1340000,
    rating: 9.5,
    description: "探寻中国美食背后的故事，感受中华饮食文化的博大精深。",
    tags: ["美食", "纪录片", "文化"],
  },
];

export const articles = [
  {
    id: 1,
    title: "2024年最值得期待的10部国产电影",
    excerpt: "从科幻大片到文艺佳作，这份片单涵盖了今年最不容错过的国产电影作品。",
    content: "2024年的中国电影市场精彩纷呈，多部备受期待的大片即将上映。从张艺谋导演的最新力作，到新生代导演的突破之作，每一部都值得走进电影院观看……科幻题材方面，《流浪地球3》将继续延续前作的宏大叙事；文艺片领域，《隐入尘烟》导演的新作也备受关注。动画电影方面，追光动画的新作将再次挑战国产动画的技术天花板……",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20cinema%20movie%20theater%20entrance%20with%20film%20posters%2C%20warm%20cinematic%20lighting%2C%20elegant%20interior%20design%2C%20modern%20movie%20theater%20aesthetic%2C%20rich%20red%20and%20gold%20tones%2C%20professional%20commercial%20photography&width=800&height=450&seq=article-thumb-01&orientation=landscape",
    author: "影视编辑组",
    date: "2024-08-01",
    tags: ["电影推荐", "国产电影", "2024"],
    views: 56000,
  },
  {
    id: 2,
    title: "AI技术如何改变在线教育行业",
    excerpt: "人工智能正在深刻变革教育方式，从个性化学习到智能评估，未来已来。",
    content: "随着ChatGPT等大语言模型的爆发式增长，AI技术正在以前所未有的速度渗透到教育领域。个性化学习路径、智能作业批改、虚拟教师助手……这些曾经科幻电影中的场景，如今正在变成现实……在K12教育领域，AI自适应学习系统已经能够根据每个学生的学习进度和理解能力，动态调整教学内容和难度……高等教育方面，多所顶尖大学已经开始将AI工具整合到课程中……",
    category: "keji",
    thumbnail: "https://readdy.ai/api/search-image?query=Futuristic%20online%20education%20classroom%20with%20holographic%20displays%2C%20students%20learning%20with%20technology%2C%20warm%20modern%20aesthetic%2C%20clean%20design%2C%20educational%20technology%20photography%2C%20soft%20natural%20light%20from%20windows&width=800&height=450&seq=article-thumb-02&orientation=landscape",
    author: "科技观察员",
    date: "2024-07-28",
    tags: ["AI", "教育", "科技趋势"],
    views: 42000,
  },
  {
    id: 3,
    title: "从《甄嬛传》看中国古装剧的黄金时代",
    excerpt: "宫斗剧的热潮背后，是中国电视剧工业化水平的全面提升。",
    content: "《甄嬛传》播出已经超过十年，但它在中国电视剧史上的地位依然不可撼动。这部剧不仅创造了收视神话，更开启了中国古装剧的黄金时代……从服化道的精良制作，到演员的精湛演技，再到剧本的扎实功底，《甄嬛传》为后来的古装剧树立了一个几乎无法逾越的标杆……近年来，《如懿传》《延禧攻略》等作品延续了这一传统，但在深度和广度上各有千秋……",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20set%20with%20elegant%20palace%20furniture%2C%20traditional%20Chinese%20decor%2C%20warm%20amber%20lighting%2C%20classical%20aesthetic%2C%20film%20production%20design%20photography%2C%20rich%20cultural%20atmosphere&width=800&height=450&seq=article-thumb-03&orientation=landscape",
    author: "文化评论家",
    date: "2024-07-25",
    tags: ["古装剧", "甄嬛传", "电视剧"],
    views: 38000,
  },
  {
    id: 4,
    title: "NBA新赛季五大看点：谁将问鼎总冠军",
    excerpt: "新赛季阵容大洗牌，多支球队实力飙升，冠军争夺将更加激烈。",
    content: "NBA新赛季即将拉开帷幕，经过休赛期的运作，联盟格局发生了巨大变化。卫冕冠军能否延续统治？新组建的超级球队能否兑现天赋？这些都将成为新赛季最令人期待的话题……西部方面，掘金队依然是最大热门，但湖人队的补强也不容小觑……东部方面，凯尔特人队保持了核心阵容的稳定，而雄鹿队的超级组合令人期待……",
    category: "tiyu",
    thumbnail: "https://readdy.ai/api/search-image?query=NBA%20basketball%20arena%20with%20players%20in%20action%2C%20dramatic%20sports%20photography%2C%20warm%20arena%20lighting%2C%20professional%20basketball%20atmosphere%2C%20intense%20game%20moment%2C%20rich%20contrast%20and%20dynamic%20composition&width=800&height=450&seq=article-thumb-04&orientation=landscape",
    author: "体育评论员",
    date: "2024-07-22",
    tags: ["NBA", "篮球", "赛季前瞻"],
    views: 29000,
  },
  {
    id: 5,
    title: "暑期档动画电影大盘点：全家欢观影指南",
    excerpt: "暑假到了，带孩子看什么动画片？这份指南帮你轻松选片。",
    content: "暑期档是动画电影的必争之地，今年更是有多部重磅作品扎堆上映。国产动画方面，《哪吒之魔童降世》续集终于要和观众见面了，这部承载了无数期待的续作能否再创票房奇迹？好莱坞方面，皮克斯和迪士尼也带来了各自的最新力作……对于家长来说，如何在众多选择中挑出最适合孩子的影片，确实是一件需要花心思的事情……",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Colorful%20animated%20movie%20theater%20scene%20with%20families%20and%20children%2C%20bright%20posters%2C%20warm%20cinema%20lighting%2C%20joyful%20atmosphere%2C%20family%20entertainment%20photography%2C%20vibrant%20and%20cheerful%20aesthetic&width=800&height=450&seq=article-thumb-05&orientation=landscape",
    author: "亲子编辑",
    date: "2024-07-18",
    tags: ["动画", "暑期档", "亲子"],
    views: 33000,
  },
  {
    id: 6,
    title: "短视频时代的纪录片突围之路",
    excerpt: "在碎片化观看习惯盛行的今天，长纪录片如何找到自己的观众？",
    content: "短视频的崛起改变了人们的观看习惯，15秒到3分钟的碎片化内容占据了用户大量的注意力时间。在这种大环境下，时长动辄一小时的纪录片似乎显得有些格格不入。但有趣的是，近年来优质纪录片的热度不降反升……《地球脉动》《舌尖上的中国》《我在故宫修文物》等现象级纪录片证明了，只要内容足够优质，观众愿意为深度内容付出时间……",
    category: "jiaoyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Professional%20documentary%20filmmaking%20setup%20with%20camera%20equipment%20in%20nature%2C%20golden%20hour%20lighting%2C%20cinematic%20production%20aesthetic%2C%20warm%20natural%20tones%2C%20behind%20the%20scenes%20photography%2C%20creative%20filmmaking%20atmosphere&width=800&height=450&seq=article-thumb-06&orientation=landscape",
    author: "媒体观察",
    date: "2024-07-15",
    tags: ["纪录片", "短视频", "内容创作"],
    views: 25000,
  },
];

export const faqs = [
  {
    question: "精品视频平台支持哪些设备观看？",
    answer: "精品视频平台全面支持PC端、手机端、平板端以及智能电视等多种设备观看。您可以通过浏览器直接访问，也可以下载我们的移动应用，随时随地畅享高清视频内容。所有设备间观看记录自动同步，让您在不同设备间无缝切换。",
  },
  {
    question: "视频的画质如何？支持多少分辨率？",
    answer: "平台所有视频均提供高清画质，最低支持720P分辨率，大部分内容支持1080P全高清，部分精选内容更提供4K超高清画质选项。系统会根据您的网络状况自动选择最佳画质，您也可以手动调整分辨率设置。",
  },
  {
    question: "需要付费才能观看吗？",
    answer: "精品视频平台提供大量免费内容供用户观看，包括热门影视、教育课程、综艺节目等。同时，我们也提供VIP会员服务，会员可以享受无广告观看、独家内容、4K超清画质、离线下载等专属权益。",
  },
  {
    question: "多久更新一次新内容？",
    answer: "我们每天都会更新新内容！热门电视剧和综艺节目通常在播出后2小时内上线，电影资源每周五集中更新，教育类课程按照教学计划定期发布。关注我们的首页推荐和分类频道，不错过任何精彩内容。",
  },
  {
    question: "如何反馈观看中遇到的问题？",
    answer: "如您在观看过程中遇到任何问题，可以通过'关于我们'页面的联系方式与我们取得联系。我们的客服团队会在24小时内响应您的问题。也可以在视频播放页面使用'报错'功能，帮助我们快速定位和解决问题。",
  },
  {
    question: "可以下载视频离线观看吗？",
    answer: "VIP会员可以在移动端和PC端下载视频进行离线观看，下载的视频在会员有效期内可以随时观看。每个视频支持下载到最多3台设备，方便您在不同设备上观看。免费用户暂时不支持下载功能。",
  },
];